import axios, { AxiosResponse } from 'axios';
import { Pais  } from './suite.interfaces';
import { CommonService } from './common.services';

export class GeneralService extends CommonService {

  async findPaisesBy(): Promise<Pais[]> {
    try {      
      const response: AxiosResponse<Pais[]> = await axios.get(super.getServerUrl() + '/mobile/findPaisesBy', { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }
}

